import React from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../../../_metronic/layout";
import HistoryRegPage from "./historyPayment";
import ReadyForPayment from "./readyForPayment";
import HistoryPayment from "./historyPayment";
import DuringPayment from "./duringPayment";
import TablePaymentRequest from "./tablePaymentRequest";
import DetailLoanReadOnly from "../detailLoan_readOnly/detailLoanReadOnly";

export default function SettlementConfigPage() {
  return (
    <Switch>
      {
        <Redirect
          exact={true}
          from="/settlement"
          to="/settlement/settlementHistory"
        />
      }

      {/* during */}
      <ContentRoute
        path="/settlement/settlementDuring/paymentRequestInfo1/loan-detail"
        component={DetailLoanReadOnly}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/settlement/settlementDuring/paymentRequestInfo"
        component={TablePaymentRequest}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/settlement/settlementDuring"
        component={DuringPayment}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      {/* during */}
      {/* history */}
      <ContentRoute
        path="/settlement/settlementHistory/paymentRequestInfo1/loan-detail"
        component={DetailLoanReadOnly}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/settlement/settlementHistory/paymentRequestInfo"
        component={TablePaymentRequest}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/settlement/settlementHistory"
        component={HistoryPayment}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      {/* history */}

      <ContentRoute
        path="/settlement/forPayment"
        component={ReadyForPayment}
        label={undefined}
        children={undefined}
        render={undefined}
      />
    </Switch>
  );
}
